import React, { useEffect } from "react";
import { Col, Image, Row } from "react-bootstrap";
import VouchurePic from "../../assets/vouchure.svg";
import CouponPic from "../../assets/coupens.svg";
import ShopPic from "../../assets/Shop.svg";
import Checked from "../../assets/checked.svg";
import GreenChecked from "../../assets/Greenchecked.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CompareModal from "../../Components/CompareModal/CompareModal";
import { GetSubscriptiondetailsApi } from "../../Utils/Api/GetSubscriptiondetailsApi";
import { userId } from "../../Utils/LocalStorage";
import { toast } from "react-toastify";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import Loader from "../../Components/Loader/Loader";
import { CompareSubscriptionApi } from "../../Utils/Api/CompareSubscriptionApi";
import { useDispatch, useSelector } from "react-redux";
import { getMySubscriptionPlanId } from "../../redux/MyProfileSubscriptionSlice";
import { RotatingLines } from "react-loader-spinner";
import { MdDelete } from "react-icons/md";
import DeletePopUp from "../../Components/DeletePopUp/DeletePopUp";
import { DeleteProfileAPI } from "../../Utils/Api/DeleteProfileAPI";
import getFormatedDate from "../../Utils/DateFormatter";

const MyProfileSubscription = () => {
  const [modalShow, setModalShow] = useState(false);
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);
  const [CompareSubscriptionData, setCompareSubscriptionData] = useState({});
  const [activeNumberOfVouchers, setActiveNumberOfVouchers] = useState(0);
  const [activeNoOfCoupons, setActiveNoOfCoupons] = useState(0);
  const [currentPlan, setCurrentPlan] = useState(0);
  const [btnloading, setBtnloading] = useState(false);
  const [btnTwoloading, setBtnTwoloading] = useState(false);
  const [subscriptionDetailsDate, setSubscriptionDetailsDate] = useState("");
  const [planIdFlag, setPlanIdFlag] = useState("");
  const [totalSubscribedMarketplaces, setTotalSubscribedMarketplaces] =
    useState(0);
  const [loading, setLoading] = useState(false);
  const [deletemodalShow, setDeleteModalShow] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [SubscriptionRenewMessage, setSubscriptionRenewMessage] = useState("");
  const [renewStatusLoaded, setRenewStatusLoaded] = useState(false);

  const navigate = useNavigate();
  const Uid = userId();
  const dispatch = useDispatch();

  // Redux Data
  const ReduxData = useSelector((state) => state);

  // Charge bee check flag
  const CheckChargebeeSubscriptionFlag =
    ReduxData.CheckChargebee.CheckChargebeeSubscription;

  const GetSubscriptiondetails = async () => {
    const data = {
      user_id: Uid,
    };
    setLoading(true);
    const GetSubscriptiondetailsRes = await GetSubscriptiondetailsApi(
      data,
      () => {
        navigate("/");
      }
    );
    if (GetSubscriptiondetailsRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (GetSubscriptiondetailsRes.success === true) {
        setSubscriptionDetails(
          GetSubscriptiondetailsRes.data.subscription_data
        );
        setSubscriptionDetailsDate(
          GetSubscriptiondetailsRes.data.subscription_end_date
        );
        setActiveNumberOfVouchers(GetSubscriptiondetailsRes.data.voucher_count);
        setActiveNoOfCoupons(GetSubscriptiondetailsRes.data.coupon_count);
        setTotalSubscribedMarketplaces(
          GetSubscriptiondetailsRes.data.marketplace_count
        );
        setCurrentPlan(GetSubscriptiondetailsRes.data.current_plan);
        setDeleteStatus(GetSubscriptiondetailsRes?.deleted_account_status);
        setLoading(false);
      } else if (GetSubscriptiondetailsRes.status === 429) {
        setLoading(true);
        toast.error(GetSubscriptiondetailsRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        setSubscriptionDetails([]);
        setActiveNumberOfVouchers(0);
        setActiveNoOfCoupons(0);
        setTotalSubscribedMarketplaces(0);
        setLoading(false);
      }
    }
  };

  const deleteHandler = (e) => {
    e.preventDefault();
    setDeleteModalShow(true);
  };

  const dummydata = [
    {
      currentplanflag: 0,
      Title: subscriptionDetails[0]?.subscription_name,
      Heading: subscriptionDetails[0]?.subscription_price,
      BulletPoints: [
        subscriptionDetails[0]?.subscription_marketplace_count +
          " " +
          "Marketplace",
        subscriptionDetails[0]?.subscription_voucher_count + " " + "Voucher",
        subscriptionDetails[0]?.subscription_coupon_count + " " + "Coupon",
      ],
      status: subscriptionDetails[0]?.subscription_id,
      recomended: subscriptionDetails[0]?.subscription_is_recommended,
      CheckSubscriptionFlag: CheckChargebeeSubscriptionFlag,
      CheckSubscriptionRenewFlag:
        ReduxData.CheckChargebee.subscrption_renew_status,
    },
    {
      currentplanflag: 1,
      Title: subscriptionDetails[1]?.subscription_name,
      Heading: subscriptionDetails[1]?.subscription_price,
      BulletPoints: [
        subscriptionDetails[1]?.subscription_marketplace_count +
          " " +
          "Marketplace",
        subscriptionDetails[1]?.subscription_voucher_count + " " + "Voucher",
        subscriptionDetails[1]?.subscription_coupon_count + " " + "Coupon",
      ],
      status: subscriptionDetails[1]?.subscription_id,
      recomended: subscriptionDetails[1]?.subscription_is_recommended,
      CheckSubscriptionFlag: CheckChargebeeSubscriptionFlag,
      CheckSubscriptionRenewFlag:
        ReduxData.CheckChargebee.subscrption_renew_status,
    },
    {
      currentplanflag: 2,
      Title: subscriptionDetails[2]?.subscription_name,
      Heading: subscriptionDetails[2]?.subscription_price,
      BulletPoints: [
        subscriptionDetails[2]?.subscription_marketplace_count +
          " " +
          "Marketplace",
        subscriptionDetails[2]?.subscription_voucher_count + " " + "Voucher",
        subscriptionDetails[2]?.subscription_coupon_count + " " + "Coupon",
      ],
      status: subscriptionDetails[2]?.subscription_id,
      recomended: subscriptionDetails[2]?.subscription_is_recommended,
      CheckSubscriptionFlag: CheckChargebeeSubscriptionFlag,
      CheckSubscriptionRenewFlag:
        ReduxData.CheckChargebee.subscrption_renew_status,
    },
    // {
    //   currentplanflag: 3,
    //   Title: subscriptionDetails[3]?.subscription_name,
    //   Heading: subscriptionDetails[3]?.subscription_price,
    //   BulletPoints: [
    //     subscriptionDetails[3]?.subscription_marketplace_count +
    //       " " +
    //       "Marketplace",
    //     subscriptionDetails[3]?.subscription_voucher_count + " " + "Voucher",
    //     subscriptionDetails[3]?.subscription_coupon_count + " " + "Coupon",
    //   ],
    //   status: subscriptionDetails[3]?.subscription_id,
    //   recomended: subscriptionDetails[3]?.subscription_is_recommended,
    //   CheckSubscriptionFlag: CheckChargebeeSubscriptionFlag,
    // },
    // {
    //   currentplanflag: 4,
    //   Title: subscriptionDetails[4]?.subscription_name,
    //   Heading: subscriptionDetails[4]?.subscription_price,
    //   BulletPoints: [
    //     subscriptionDetails[4]?.subscription_marketplace_count +
    //       " " +
    //       "Marketplace",
    //     subscriptionDetails[4]?.subscription_voucher_count + " " + "Voucher",
    //     subscriptionDetails[4]?.subscription_coupon_count + " " + "Coupon",
    //   ],
    //   status: subscriptionDetails[4]?.subscription_id,
    //   recomended: subscriptionDetails[4]?.subscription_is_recommended,
    //   CheckSubscriptionFlag: CheckChargebeeSubscriptionFlag,
    // },
  ];

  // const titles = dummydata.map((item) => item.Title);

  // const ChangePlan = (status, flag) => {
  //   if (status === 0) {
  //     if (flag === 0) {
  //       navigate("/my-profile/subscription/free-plan-details");
  //     } else if (flag === 1) {
  //       navigate("/my-profile/subscription/tier-II-details");
  //     } else {
  //       navigate("/my-profile/subscription/tier-III-details");
  //     }
  //   }
  // };

  const CompareModalApiHandler = async (planId) => {
    setPlanIdFlag(planId);

    const data = {
      user_id: Uid,
      plan_id: planId,
      current_plan_id: currentPlan,
    };

    setBtnloading(true);
    const CompareModalApiRes = await CompareSubscriptionApi(data, () => {
      navigate("/");
    });
    if (CompareModalApiRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setBtnloading(false);
    } else {
      if (CompareModalApiRes.success === true) {
        if (planId === 1) {
          dispatch(getMySubscriptionPlanId(planId));
          navigate("/my-profile/subscription/tier-details");
        } else if (planId === 2) {
          dispatch(getMySubscriptionPlanId(planId));
          navigate("/my-profile/subscription/tier-details");
        } else {
          dispatch(getMySubscriptionPlanId(planId));
          navigate("/my-profile/subscription/tier-details");
        }
        setBtnloading(false);
      } else if (CompareModalApiRes.status === 429) {
        setLoading(true);
        toast.error(CompareModalApiRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        if (CompareModalApiRes.is_eligible === false) {
          setCompareSubscriptionData(CompareModalApiRes.data);
          setBtnloading(false);
          setModalShow(true);
        }
      }
    }
  };

  const DeleteHandlerApi = async (data) => {
    setBtnTwoloading(true);
    const DeleteRes = await DeleteProfileAPI(data, () => {
      navigate("/");
    });
    if (DeleteRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setBtnTwoloading(false);
    } else {
      if (DeleteRes.success === true) {
        toast.success(DeleteRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setDeleteModalShow(false);
        setBtnTwoloading(false);
        localStorage.clear();
        navigate("/");
      }
      if (DeleteRes.status === 429) {
        setLoading(true);
        toast.error(DeleteRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.error(DeleteRes.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setBtnTwoloading(false);
      }
    }
  };

  useEffect(() => {
    GetSubscriptiondetails();
  }, []);

  // console.log(
  //   "subscriptionDetails",
  //   ReduxData.CheckChargebee.subscrption_renew_status
  // );

  return (
    <div className="MyProfileSubscription">
      {loading === true ? <Loader /> : ""}
      <Row className="dashboard-card mt-4 ">
        <Col md="4">
          <div className="card">
            <div className="dash-img-main">
              <div className="dash-img">
                <Image loading="lazy" src={VouchurePic} height="15px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Active No of vouchers</p>
              <p className="dash-text2">
                {activeNumberOfVouchers ? activeNumberOfVouchers : 0}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
        <Col md="4">
          <div className="card">
            <div className="dash-img-main">
              <div className="dash-img">
                <Image loading="lazy" src={CouponPic} height="25px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Active No of Coupons</p>
              <p className="dash-text2">
                {activeNoOfCoupons ? activeNoOfCoupons : 0}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
        <Col md="4">
          <div className="card">
            <div className="dash-img-main">
              <div className="dash-img">
                <Image loading="lazy" src={ShopPic} height="20px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">total subscribed marketplaces</p>
              <p className="dash-text2">
                {totalSubscribedMarketplaces ? totalSubscribedMarketplaces : 0}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
      </Row>
      {currentPlan !== 1 ? (
        <p className="renewal_Date">
          Subscription Plan Renewal Date:
          <span>{getFormatedDate(subscriptionDetailsDate)}</span>
        </p>
      ) : (
        <div className="empty_space"></div>
      )}
      {ReduxData.CheckChargebee.subscrption_renew_status && (
        <div className="renew-section container mt-3">
          <div className="renew-plan-notice row align-items-center">
            <div className="col-md-8">
              <div className="renew-box">
                <div className="message">
                  {ReduxData.CheckChargebee.subscriptionRenewMessage}
                </div>
              </div>
            </div>
            <div className="col-md-4 text-md-end mt-2 mt-md-0 justify-content-end ">
              <button
                className="renew-btn green-btn btn btn-primary"
                onClick={() => CompareModalApiHandler(currentPlan)}
              >
                Renew Plan
              </button>
            </div>
          </div>
        </div>
      )}

      <Row
        className={
          subscriptionDetails?.length > 0
            ? "mt-4 TierCardRow TierCard_padding"
            : "mt-4 TierCardRow"
        }
        style={
          ReduxData.CheckChargebee.subscrption_renew_status
            ? { filter: "blur(4px)", pointerEvents: "none" }
            : {}
        }
      >
        {subscriptionDetails?.length > 0
          ? dummydata?.map((data, i) => {
              const getPlanText = () => {
                if (data.status === currentPlan) {
                  if (
                    (data.CheckSubscriptionFlag &&
                      data.CheckSubscriptionRenewFlag) ||
                    (!data.CheckSubscriptionFlag &&
                      data.CheckSubscriptionRenewFlag)
                  ) {
                    return "Renew Plan";
                  } else {
                    return "Current Plan";
                  }
                } else {
                  return "Change Plan";
                }
              };

              const planText = getPlanText();
              return (
                <>
                  {data.Heading !== undefined ? (
                    <Col
                      key={i}
                      className={
                        data.status === currentPlan
                          ? "TierCard CurrentTier"
                          : data.recomended === 1
                          ? "TierCard recommended"
                          : "TierCard"
                      }
                      md="4"
                    >
                      <p className="planP">{data.Title}</p>
                      <h1>
                        ${data.Heading}
                        <span>per month</span>
                      </h1>
                      <div className="TierList">
                        {data.BulletPoints.map((b, i) => {
                          return (
                            <li key={i}>
                              <img
                                loading="lazy"
                                src={
                                  data.status === currentPlan
                                    ? GreenChecked
                                    : Checked
                                }
                              />
                              {b} <span>(active)</span>
                            </li>
                          );
                        })}
                      </div>
                      <p
                        className={
                          planText === "Current Plan" ? "planTag" : "ChangeTag"
                        }
                        onClick={() => {
                          if (planText === "Current Plan") {
                            setModalShow(false);
                          } else {
                            CompareModalApiHandler(data.status);
                          }
                        }}
                      >
                        <b>
                          {planIdFlag === data.status &&
                          btnloading &&
                          planText !== "Current Plan" ? (
                            <RotatingLines
                              strokeColor="white"
                              width={20}
                              visible={true}
                            />
                          ) : (
                            planText
                          )}
                        </b>
                      </p>

                      {data.recomended === 1 ? (
                        <p className="RecommendedTag">Recommended</p>
                      ) : null}
                    </Col>
                  ) : null}
                </>
              );
            })
          : null}
      </Row>

      <div className="delete_My_Account">
        <button onClick={deleteHandler}>
          Delete Account
          <MdDelete />
        </button>
      </div>
      <CompareModal
        show={modalShow}
        CompareData={CompareSubscriptionData}
        onHide={() => setModalShow(false)}
      />
      <DeletePopUp
        CityID={Uid}
        DeleteFuc={DeleteHandlerApi}
        btnloading={btnTwoloading}
        show={deletemodalShow}
        deleted_account_status={deleteStatus}
        onHide={() => setDeleteModalShow(false)}
      />
    </div>
  );
};
export default MyProfileSubscription;
